import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import './PrintPass.css';

const PrintPass = () => {
  const { id } = useParams();
  const [passData, setPassData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [logo, setLogo] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const base_url = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${base_url}/visitor/detail/${id}`)
      .then((res) => {
        const visitorData = res.data.data;
        setPassData(visitorData);
        console.log("Pass Data", visitorData);
        let isExpired = false;
        const now = new Date();
        if (visitorData.passType === 'PreBooking') {
          // For PreBooking, check createdFor date
          if (visitorData.createdFor) {
            const passDate = new Date(visitorData.createdFor);
            isExpired = passDate < now;
          }
        } else {
          // For normal passes, check created date
          if (visitorData.createdAt) {
            const passDate = new Date(visitorData.createdAt);
            // Check if pass is older than 1 day
            const oneDayInMs = 24 * 60 * 60 * 1000;
            isExpired = (now - passDate) > oneDayInMs;
          }
        }

        /*if (isExpired) {
          navigate('/expired-pass');
          return;
        } */
        if (visitorData.companyId) {
          return axios(
            `${base_url}/visitor/company/details/${visitorData.companyId}`
          );
        }
        return null;
      })
      .then((companyRes) => {
        if (companyRes && companyRes.data) {
          console.log("Company Data", companyRes.data.data);
          setLogo(companyRes.data.data.logo);
          setCompanyData(companyRes.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching pass details:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, base_url]);

  if (loading) {
    return (
      <div className="print-loading">
        <div className="spinner"></div>
        <p>Preparing pass for printing...</p>
      </div>
    );
  }

  if (!passData) {
    return <div className="print-error">Error loading pass data</div>;
  }

  return (
    <div className="print-container">
      <div className="id-card">

        {/* Header with Left Image, Center DigiPass, and Right Company Logo */}
        <div className="id-card-header" style={{
          background: ["Normal", "PreBooking"].includes(passData.passType)
            ? "blue"
            : passData.passType === "Vendor"
              ? "linear-gradient(to top, #0f531d, #06521b)"
              : "linear-gradient(to top, #edd52a, #c99a29)",
          borderRadius: "0",
          height: "50px"
        }}>
          <img
            src={require("../../../assets/img/visitor-images/images/logo.png")}
            alt="Logo"
            className="left-logo"
          />

          <span className="digipass-text">DigiPass</span>

          {
            logo ? (
              <img
                src={logo}
                alt="Company Logo"
                className="company-logo"
              />
            ) : (
              <div className="no-logo">No Logo</div>
            )
          }
        </div>

        {/* Pass Type */}
        <div className="pass-type">
          {passData.passType === 'PreBooking' ? 'VISITOR' : 'VISITOR'}
        </div>

        {/* Photo and QR Code Container */}
        <div
          className={companyData?.boombarierQrCheck ? "photo-qr-container" : "id-card-photo"}
        >
          {passData.selfie ? (
            <img
              src={passData.selfie}
              alt="Visitor"
              className="visitor-photo"
            />
          ) : (
            <div className="visitor-photo-initial">
              {passData.firstName ? passData.firstName.charAt(0).toUpperCase() : 'V'}
            </div>
          )}

          {companyData?.boombarierQrCheck && (
            <div className="qr-code-container">
              <QRCodeSVG
                value={`https://digipass.co.in/digipass/${passData._id}`}
                size={100}
                level="H"
                fgColor="#0a66c2"
              // bgColor="#ffffff"
              />
            </div>
          )}
        </div>



        {/* Visitor Name */}
        <div className="visitor-name">
          {passData.firstName + " " + passData.lastName || 'Visitor Name'}
        </div>

        {/* Main Details */}
        <div className="id-card-details">
          <div className="detail-row">
            <span className="label">Phone</span>
            <span className="value">{passData.phone || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="label">Valid For</span>
            <span className="value">{passData.createdForDate ? passData.createdForDate.substring(0, 10) : passData.createdAt.substring(0, 10)}
            </span>
          </div>
          <div className="detail-row">
            {passData.empName &&
              <>
                <span className="label">Person to Visit</span>
                <span className="value">{passData.empName || 'N/A'}</span>
              </>
            }
          </div>

          <div className="detail-row">
            {passData.empDepartment &&
              <>
                <span className="label">Department</span>
                <span className="value">{passData.empDepartment || 'N/A'}</span>
              </>
            }
          </div>
        </div>

        {/* Footer */}
        <div className="id-card-footer">
        Powered by Fedicoms Pvt Ltd.
        </div>
      </div>
    </div>
  );
};

export default PrintPass;
